import { combineReducers } from "redux";
import WalletConnectorReducer from "./WalletConnectorReducer";
import UserReducer from "./UserReducer";
import PageReducer from "./PageReducer";
import BankAccountReducer from "./BankAccountReducer";
import BuyReducer from "./BuyReducer";
import WalletReducer from "./WalletReducer";
import TransferReducer from "./TransferReducer";
import RecipientReducer from "./RecipientReducer";
import CheckoutReducer from "./CheckoutReducer";
import PaymentGatewayReducer from "./PaymentGatewayReducer";

  const appReducer= combineReducers({
  walletConnector: WalletConnectorReducer,
  user: UserReducer,
  page: PageReducer,
  bankAccount: BankAccountReducer,
  buy: BuyReducer,
  wallet: WalletReducer,
  transfer: TransferReducer,
  recipient: RecipientReducer,
  checkout: CheckoutReducer,
  paymentgateway: PaymentGatewayReducer,
});

const rootReducer = (state, action) => {
  if (action.type === "RESET_STATE_START") {
    state = undefined; 
  }
  return appReducer(state, action);
};

export default rootReducer;
